import { render, staticRenderFns } from "./bindBot.vue?vue&type=template&id=398f6f1f&scoped=true"
import script from "./bindBot.vue?vue&type=script&lang=js"
export * from "./bindBot.vue?vue&type=script&lang=js"
import style0 from "./bindBot.vue?vue&type=style&index=0&id=398f6f1f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398f6f1f",
  null
  
)

export default component.exports